// extracted by mini-css-extract-plugin
module.exports = {"root":"StarRatingDisplay_root__bXpAb","star":"StarRatingDisplay_star__q_vG8","half":"StarRatingDisplay_half__QNlE8"};